import { Validator } from '@vista-digital/validator';
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor["Primary"] = "Primary";
    ButtonColor["Secondary"] = "Secondary";
    ButtonColor["Tertiary"] = "Tertiary";
})(ButtonColor || (ButtonColor = {}));
export const defaultButtonColor = ButtonColor.Secondary;
export const buttonColorValidator = Validator.oneOf(Object.values(ButtonColor));
